import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatSelectModule,
  MatInputModule,
  MatCardModule,
  MatDialogModule
} from '@angular/material';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule, Title, Meta } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { SliderCarouselModule } from 'slider-carousel';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Routes } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRippleModule } from '@angular/material/core';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';

import { CeiboShare } from 'ng2-social-share';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BirdComponent } from './bird/bird.component';
import { BirdService } from './bird/bird.service';
import { WindowRef } from './window/service/window.service';
import { FlickrService } from './flickr/flickr.service';
import { PictureDialogComponent } from './dialog/picture-dialog/picture-dialog.component';
import { AudioMapComponent } from './bird/map/audio-map/audio-map.component';
import { SpeciesComponent } from './pais/species/species.component';
import { ListadoComponent } from './pais/listado/listado.component';
import { SightMapComponent } from './bird/map/sight-map/sight-map.component';
import { MainComponent } from './menu/main/main.component';
import { BuscarComponent } from './specie/taxo/buscar/buscar.component';
import { ColorListadoComponent } from './specie/color-listado/color-listado.component';
import { ImagesMapComponent } from './bird/map/images-map/images-map.component';
import { TaxoFamiliaComponent } from './specie/taxo/list/taxo-familia/taxo-familia.component';
import { TaxoOrderComponent } from './specie/taxo/list/taxo-order/taxo-order.component';

const appRoutes: Routes = [
  { path: 'bird/:sciname/:idioma', component: BirdComponent },
  { path: 'bird/audio/map/:sciname/:idioma', component: AudioMapComponent },
  { path: 'bird/sight/map/:sciname/:idioma', component: SightMapComponent },
  { path: 'bird/image/map/:sciname/:idioma', component: ImagesMapComponent },
  { path: 'pais/species/:country/:idioma', component: SpeciesComponent },
  { path: 'species/familias', component: BuscarComponent },
  { path: 'species/color/:color/:idioma', component: ColorListadoComponent },
  { path: 'paises', component: ListadoComponent },
  { path: 'taxo/order/:order/:idioma', component: TaxoOrderComponent },
  { path: 'taxo/family/:order/:family/:idioma', component: TaxoFamiliaComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    BirdComponent,
    PictureDialogComponent,
    AudioMapComponent,
    SpeciesComponent,
    ListadoComponent,
    CeiboShare,
    SightMapComponent,
    MainComponent,
    BuscarComponent,
    ColorListadoComponent,
    ImagesMapComponent,
    TaxoFamiliaComponent,
    TaxoOrderComponent
  ],
  entryComponents: [
    PictureDialogComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatListModule,
    SliderCarouselModule,
    FlexLayoutModule,
    MatIconModule,
    MatSidenavModule,
    MatCardModule,
    MatGridListModule,
    MatTabsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    Angular2FontawesomeModule,
    MatMenuModule,
    VirtualScrollerModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatRippleModule,
    MatProgressBarModule,
    ScrollDispatchModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBALtJkcwkI_8cN46O4oVWf8rCX5dNSAkM'
    }),
    AgmJsMarkerClustererModule,
    AgmSnazzyInfoWindowModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true }
    )
  ],
  providers: [
    WindowRef,
    BirdService,
    FlickrService,
    Title,
    Meta
  ],
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatListModule,
    MatSidenavModule,
    MatCardModule,
    MatGridListModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    VirtualScrollerModule,
    MatToolbarModule,
    MatRippleModule,
    MatSnackBarModule,
    MatProgressBarModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
